import { useI18n } from "hooks/i18n/i18n";
import { useState } from "react";

export const useThis = () => {
  const [isOpenedCollapse, setIsOpenedCollapse] = useState(false);
  const { t } = useI18n();
  const handleToggleRootCollapse = () => {
    setIsOpenedCollapse((current) => !current);
  };
  const rootCollapseTitle = t("common.string.location.area");

  return { handleToggleRootCollapse, isOpenedCollapse, rootCollapseTitle };
};
